module.exports = __webpack_public_path__ + "img/valleint5.dfb6ae8a.png";